'use strict';

import API from '../../../../common-js/framework/API';
import rstore from '../global/rstore';  // Frontend Redux store

export default function(command, params) {
    return API(command, params, rstore, true);
}



// WEBPACK FOOTER //
// ./src/api/api.js